module.exports = __webpack_public_path__ + "static/img/Background.5fdabf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Background.jpg
// module id = 0i6I
// module chunks = 1